(() => {
  // app/scripts/article-page.js
  sidebar_menu_handle = () => {
    let elements = document.querySelectorAll(".categories-menu .dropdown .expand ,.sidebar-column .sb-filter");
    elements.forEach((e) => {
      e.addEventListener("click", () => {
        if (e.classList.contains("active") && !e.classList.contains("del-before")) {
          e.classList.remove("active");
          e.parentElement.classList.remove("active");
        } else {
          if (!e.classList.contains("del-before")) {
            e.classList.remove("active");
          }
          e.classList.add("active");
          e.parentElement.classList.add("active");
        }
      });
    });
    if (document.getElementsByClassName("grid-uniform").length) {
      document.querySelectorAll(".grid-uniform").forEach((e) => {
        if (e.querySelector(".advanced-filters").childElementCount == 0) {
          e.parentElement.parentElement.remove();
        }
      });
    }
  };
  sidebar_menu_handle();
})();
